import React from 'react';
import './Item.css';

export default ({link}) => (
    <div className="youtube-item">
        <div>
            {link}
        </div>
    </div>
);